import { useLocation } from '@gatsbyjs/reach-router';
import { IconButton } from '@mui/material';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import Icon from '@components/Icon/Icon';
import UnreadBadge from '@components/UnreadBadge';

import { MESSENGER } from '@constants/routes';

import { useMessenger } from '@hooks/useMessenger';
import { useNavigate } from '@hooks/useNavigate';
import { useUnreadCount } from '@hooks/useUnreadCount';

import { getLocationNameArray } from '@utils/url';

const messages = defineMessages({
  unreadMessageCount: {
    id: 'messenger.unreadMessageCount',
    defaultMessage: '{count} unread messages',
  },
});

export default function UnreadMessageCount() {
  const { formatMessage } = useIntl();
  const location = useLocation();
  const { navigateRoute } = useNavigate();

  const { unreadCount, unreadCountLoading } = useUnreadCount();

  const {
    state: { renderChat },
  } = useMessenger();

  if (!renderChat) {
    return null;
  }

  const isMessengerRoute = getLocationNameArray(location).includes(
    MESSENGER.split('/')[1]
  );

  return (
    <IconButton
      aria-label={formatMessage(messages.unreadMessageCount, {
        count: unreadCount,
      })}
      onClick={() => navigateRoute(MESSENGER)}
    >
      <UnreadBadge
        unreadCount={unreadCount}
        loading={unreadCountLoading}
        color="error"
      >
        <Icon
          color="primary.main"
          name="comment"
          type={isMessengerRoute ? 'fas' : 'fat'}
        />
      </UnreadBadge>
    </IconButton>
  );
}
